import { useState } from "react"
import style from "./Planes.module.css"

const Planes = ({ handleRegister }) => {

    const [tabActivo, setTabActivo] = useState("jugador")

    const planesJugador = [
        {
            nombre: "Gratis",
            precio: "$0",
            periodo: "siempre",
            descripcion: "Empieza a medir tu rendimiento sin costo",
            destacado: false,
            features: [
                { texto: "GPS tracking básico", incluido: true },
                { texto: "Registro de entrenamientos", incluido: true },
                { texto: "BSD Score", incluido: true },
                { texto: "Feed social", incluido: true },
                { texto: "4 métricas físicas", incluido: true },
                { texto: "2 pruebas guiadas / mes", incluido: true },
                { texto: "Análisis IA: resumen", incluido: true },
                { texto: "1 rutina IA / semana", incluido: true },
                { texto: "Leaderboard local", incluido: true },
                { texto: "CV deportivo básico", incluido: true },
                { texto: "Historial: 3 meses", incluido: true },
                { texto: "Pruebas guiadas ilimitadas", incluido: false },
                { texto: "Análisis IA completo", incluido: false },
                { texto: "Análisis de video IA", incluido: false },
                { texto: "CV completo + PDF + QR", incluido: false },
                { texto: "Comparativa con promedios pro", incluido: false },
            ],
        },
        {
            nombre: "Pro",
            precio: "$4.99",
            periodo: "USD / mes",
            descripcion: "Para jugadores que van en serio con su carrera",
            destacado: true,
            features: [
                { texto: "GPS tracking básico", incluido: true },
                { texto: "Registro de entrenamientos", incluido: true },
                { texto: "BSD Score", incluido: true },
                { texto: "Feed social", incluido: true },
                { texto: "4 métricas físicas", incluido: true },
                { texto: "Pruebas guiadas ilimitadas", incluido: true },
                { texto: "Análisis IA completo semanal", incluido: true },
                { texto: "3 rutinas IA / semana", incluido: true },
                { texto: "Leaderboard nacional", incluido: true },
                { texto: "CV completo + PDF", incluido: true },
                { texto: "Historial: 12 meses", incluido: true },
                { texto: "2 análisis de video IA / mes", incluido: true },
                { texto: "Badge Pro en perfil", incluido: true },
                { texto: "Comparativa con promedios pro", incluido: false },
                { texto: "Análisis de video IA: 10/mes", incluido: false },
                { texto: "Historial ilimitado", incluido: false },
            ],
        },
        {
            nombre: "Elite",
            precio: "$9.99",
            periodo: "USD / mes",
            descripcion: "Acceso total a toda la plataforma",
            destacado: false,
            features: [
                { texto: "GPS tracking básico", incluido: true },
                { texto: "Registro de entrenamientos", incluido: true },
                { texto: "BSD Score", incluido: true },
                { texto: "Feed social", incluido: true },
                { texto: "4 métricas físicas", incluido: true },
                { texto: "Pruebas guiadas ilimitadas", incluido: true },
                { texto: "Análisis IA completo + video", incluido: true },
                { texto: "Rutinas IA diarias", incluido: true },
                { texto: "Leaderboard nacional + filtros", incluido: true },
                { texto: "CV completo + PDF + QR", incluido: true },
                { texto: "Historial ilimitado", incluido: true },
                { texto: "10 análisis de video IA / mes", incluido: true },
                { texto: "Badge Elite en perfil", incluido: true },
                { texto: "Comparativa con promedios pro", incluido: true },
                { texto: "Soporte prioritario", incluido: true },
                { texto: "Acceso anticipado a features", incluido: true },
            ],
        },
    ]

    const planesEntrenador = [
        {
            nombre: "Gratis",
            precio: "$0",
            periodo: "siempre",
            descripcion: "Ideal para empezar a gestionar tu equipo",
            destacado: false,
            features: [
                { texto: "1 equipo (máx. 15 jugadores)", incluido: true },
                { texto: "Dashboard básico", incluido: true },
                { texto: "5 evaluaciones / semana", incluido: true },
                { texto: "Convocatorias y asistencia", incluido: true },
                { texto: "Feed social", incluido: true },
                { texto: "Mensajería con jugadores", incluido: true },
                { texto: "Listas de seguimiento", incluido: true },
                { texto: "Dashboard completo", incluido: false },
                { texto: "Evaluaciones ilimitadas", incluido: false },
                { texto: "Reportes IA por jugador", incluido: false },
                { texto: "Reportes de equipo", incluido: false },
                { texto: "Exportar datos", incluido: false },
            ],
        },
        {
            nombre: "Coach",
            precio: "$14.99",
            periodo: "USD / mes",
            descripcion: "Para entrenadores que quieren profesionalizar su equipo",
            destacado: true,
            features: [
                { texto: "3 equipos (máx. 30 jugadores c/u)", incluido: true },
                { texto: "Dashboard completo", incluido: true },
                { texto: "Evaluaciones ilimitadas", incluido: true },
                { texto: "Convocatorias y asistencia", incluido: true },
                { texto: "Feed social", incluido: true },
                { texto: "Mensajería con jugadores", incluido: true },
                { texto: "Listas de seguimiento", incluido: true },
                { texto: "Reportes IA por jugador", incluido: true },
                { texto: "Filtros avanzados de búsqueda", incluido: true },
                { texto: "Badge Coach en perfil", incluido: true },
                { texto: "Reportes de equipo", incluido: false },
                { texto: "Exportar datos", incluido: false },
            ],
        },
        {
            nombre: "Club",
            precio: "$29.99",
            periodo: "USD / mes",
            descripcion: "Para academias y clubes con múltiples categorías",
            destacado: false,
            features: [
                { texto: "10 equipos (jugadores ilimitados)", incluido: true },
                { texto: "Dashboard completo + exportar", incluido: true },
                { texto: "Evaluaciones ilimitadas", incluido: true },
                { texto: "Convocatorias y asistencia", incluido: true },
                { texto: "Feed social", incluido: true },
                { texto: "Mensajería con jugadores", incluido: true },
                { texto: "Listas de seguimiento", incluido: true },
                { texto: "Reportes IA por jugador", incluido: true },
                { texto: "Reportes de equipo completos", incluido: true },
                { texto: "Exportar todos los datos", incluido: true },
                { texto: "Badge Club en perfil", incluido: true },
                { texto: "Soporte prioritario", incluido: true },
            ],
        },
    ]

    const planes = tabActivo === "jugador" ? planesJugador : planesEntrenador

    return (
        <div className={style.container}>
            {/* HERO */}
            <div className={style.hero}>
                <h1 className={style.heroTitle}>PLANES Y PRECIOS</h1>
                <p className={style.heroSub}>Elige el plan que se adapte a tus objetivos. Empieza gratis y escala cuando estés listo.</p>

                {/* TABS */}
                <div className={style.tabs}>
                    <button
                        className={`${style.tab} ${tabActivo === "jugador" ? style.tabActivo : ""}`}
                        onClick={() => setTabActivo("jugador")}
                    >
                        Jugadores
                    </button>
                    <button
                        className={`${style.tab} ${tabActivo === "entrenador" ? style.tabActivo : ""}`}
                        onClick={() => setTabActivo("entrenador")}
                    >
                        Entrenadores
                    </button>
                </div>
            </div>

            {/* PLANES */}
            <div className={style.planesSection}>
                <div className={style.planesGrid}>
                    {planes.map((plan, index) => (
                        <div
                            className={`${style.planCard} ${plan.destacado ? style.planDestacado : ""}`}
                            key={index}
                        >
                            {plan.destacado && <div className={style.planBadge}>MAS POPULAR</div>}
                            <h3 className={style.planNombre}>{plan.nombre}</h3>
                            <div className={style.planPrecio}>
                                <span className={style.precio}>{plan.precio}</span>
                                <span className={style.periodo}>{plan.periodo}</span>
                            </div>
                            <p className={style.planDesc}>{plan.descripcion}</p>
                            <button
                                className={plan.destacado ? style.btnPlanDestacado : style.btnPlan}
                                onClick={handleRegister}
                            >
                                {plan.precio === "$0" ? "Empezar gratis" : "Comenzar prueba"}
                            </button>
                            <div className={style.planDivider}></div>
                            <div className={style.featuresList}>
                                {plan.features.map((feature, fIndex) => (
                                    <div className={style.featureItem} key={fIndex}>
                                        <span className={feature.incluido ? style.featureCheck : style.featureX}>
                                            {feature.incluido ? "✓" : "—"}
                                        </span>
                                        <span className={feature.incluido ? style.featureTxt : style.featureTxtDisabled}>
                                            {feature.texto}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* FAQ */}
            <div className={style.faqSection}>
                <h2 className={style.faqTitle}>PREGUNTAS FRECUENTES</h2>
                <div className={style.faqGrid}>
                    <div className={style.faqItem}>
                        <h4 className={style.faqQ}>¿Puedo usar la app sin pagar?</h4>
                        <p className={style.faqA}>Sí. El plan gratuito incluye GPS tracking, registro de entrenamientos, BSD Score, feed social y métricas físicas. Puedes usar la app completamente sin pagar.</p>
                    </div>
                    <div className={style.faqItem}>
                        <h4 className={style.faqQ}>¿Puedo cambiar de plan después?</h4>
                        <p className={style.faqA}>Sí. Puedes subir o bajar de plan en cualquier momento. Si bajas, mantienes acceso hasta el final del período pagado.</p>
                    </div>
                    <div className={style.faqItem}>
                        <h4 className={style.faqQ}>¿Los planes son mensuales o anuales?</h4>
                        <p className={style.faqA}>Ambos. Los precios mostrados son mensuales. El plan anual tiene un descuento del 20% (2 meses gratis).</p>
                    </div>
                    <div className={style.faqItem}>
                        <h4 className={style.faqQ}>¿Qué métodos de pago aceptan?</h4>
                        <p className={style.faqA}>Aceptamos tarjetas de crédito/débito a través de la App Store (iOS) y Play Store (Android). En la versión web, también Stripe y Mercado Pago.</p>
                    </div>
                </div>
            </div>

            {/* CTA */}
            <div className={style.ctaSection}>
                <h2 className={style.ctaTitle}>EMPIEZA HOY, ES GRATIS</h2>
                <p className={style.ctaSub}>Crea tu cuenta y accede a todas las funcionalidades básicas sin costo. Mejora tu plan cuando estés listo para llevar tu rendimiento al siguiente nivel.</p>
                <button className={style.btnCta} onClick={handleRegister}>Crear mi cuenta gratis</button>
            </div>
        </div>
    )
}

export default Planes
